import { render, staticRenderFns } from "./PreferencesSettings.vue?vue&type=template&id=cc00e572&scoped=true"
import script from "./PreferencesSettings.vue?vue&type=script&lang=js"
export * from "./PreferencesSettings.vue?vue&type=script&lang=js"
import style0 from "./PreferencesSettings.vue?vue&type=style&index=0&id=cc00e572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc00e572",
  null
  
)

export default component.exports